import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';
import { PipeModule } from 'src/app/lib/pipe/pipes.module';

@Component({
  selector: 'app-help-video',
  templateUrl: './help-video.component.html',
  styleUrls: ['./help-video.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, PipeModule]
})

export class HelpVideoComponent implements OnInit {
  @Input() helpVideos: { title: string, id: string }[];

  constructor(
    private modalCtrl: ModalController,
    public commonService: CommonService,
  ) { }

  ngOnInit() { }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
